import { Autocomplete, FormControl, TextField, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Neighborhood() {
    const {
        listBairros,
        bairro, setBairro
    } = useSearch();

    const reset = () => {
        if (!bairro) {
            setBairro({ name: 'Todos' });
        }
    }

    return (
        <>
            <Typography style={styles.labelInput}>
                Bairro:
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Autocomplete
                    value={bairro}
                    onChange={(e, newValue) => setBairro(newValue)}
                    onBlur={reset}
                    isOptionEqualToValue={(a, b) => a.name === b.name}
                    disableClearable={true}
                    id="Bairro"
                    options={listBairros}
                    getOptionLabel={(option) => option.name}
                    defaultValue={{ name: 'Todos' }}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
            </FormControl>
        </>
    );
}